export const libraryStates = [
	{
		value: '11',
		label: 'Delivered',
	},
	{
		value: '12',
		label: 'Demo Sold',
	},
	{
		value: '13',
		label: 'Demo',
	},
	{
		value: '14',
		label: 'Demo Cancelled',
	},
	{
		value: '15',
		label: 'Duplicate',
	},
	{
		value: '16',
		label: 'Cancelled',
	},
];

export const LibrarySalesRepresentatives = [
	{
		value: '24',
		label: 'Maria Amador',
	},
	{
		value: '25',
		label: 'Anyeli Gonzalez',
	},
	{
		value: '26',
		label: 'Liddne Rodriguez',
	},
	{
		value: '27',
		label: 'IT',
	},
];

export const LibraryPaymentFrequency = [
	{
		value: '18',
		label: 'Mensual',
	},
	{
		value: '19',
		label: 'Trimestral',
	},
	{
		value: '20',
		label: 'Quarterly',
	},
	{
		value: '21',
		label: 'Semestral',
	},
	{
		value: '22',
		label: 'Anual',
	},
];

export const LibraryPaymentStatus = [
	{
		value: '30',
		label: 'Pending',
	},
	{
		value: '28',
		label: 'Completed',
	},
	{
		value: '29',
		label: 'Refund',
	},
];
